import { render, staticRenderFns } from "./LoadTime.vue?vue&type=template&id=18651495&scoped=true&"
import script from "./LoadTime.vue?vue&type=script&lang=js&"
export * from "./LoadTime.vue?vue&type=script&lang=js&"
import style0 from "./LoadTime.vue?vue&type=style&index=0&id=18651495&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18651495",
  null
  
)

export default component.exports